export interface ShiftAction{
    toLeft: boolean ;
    toRight: boolean;
    toLeftEnd: boolean;
    toRightEnd: boolean;
}